var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0125 7.99377V55.8688H12.0437V7.99377H52.0125ZM52.0125 3.99377H12.0437C9.83745 3.99377 8.0437 5.78752 8.0437 7.99377V55.8688C8.0437 58.075 9.83745 59.8688 12.0437 59.8688H52.0125C54.2187 59.8688 56.0125 58.075 56.0125 55.8688V7.99377C56.0125 5.78127 54.2187 3.99377 52.0125 3.99377Z",
    fill: "#E799B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0124 59.8938H20.5874V48.8938C20.5874 46.6875 22.3812 44.8938 24.5874 44.8938H56.0124C58.2187 44.8938 60.0124 46.6875 60.0124 48.8938V55.8938C60.0124 58.1063 58.2187 59.8938 56.0124 59.8938Z",
    fill: "#DC7E9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.672 34H26.444V18.424H23.672V34ZM38.089 34H40.597V17.368H37.957V24.782H37.891C37.341 24.1 36.285 23.176 34.305 23.176C31.291 23.176 29.201 25.596 29.201 28.72C29.201 31.844 31.159 34.264 34.415 34.264C35.889 34.264 37.275 33.692 38.045 32.416H38.089V34ZM31.841 28.72C31.841 27.07 33.007 25.552 34.943 25.552C36.879 25.552 38.045 27.07 38.045 28.72C38.045 30.37 36.879 31.888 34.943 31.888C33.007 31.888 31.841 30.37 31.841 28.72Z",
    fill: "#E799B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.912 57H27.424V48.504H25.912V57ZM29.3478 57H30.8598V50.484H30.8838L35.0838 57H37.0038V48.504H35.4918V54.816H35.4678L31.3518 48.504H29.3478V57ZM38.9586 57H42.1266C44.1666 57 46.6266 55.656 46.6266 52.752C46.6266 49.872 44.5386 48.504 42.3066 48.504H38.9586V57ZM40.4706 55.632V49.872H41.8506C43.6986 49.872 45.0426 50.688 45.0426 52.752C45.0426 54.816 43.4946 55.632 41.5986 55.632H40.4706ZM48.1241 57H51.2921C53.3321 57 55.7921 55.656 55.7921 52.752C55.7921 49.872 53.7041 48.504 51.4721 48.504H48.1241V57ZM49.6361 55.632V49.872H51.0161C52.8641 49.872 54.2081 50.688 54.2081 52.752C54.2081 54.816 52.6601 55.632 50.7641 55.632H49.6361Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdIcon);
export default __webpack_public_path__ + "static/media/id-icon.73e9e45891a5f787544761d7ab5d7ba1.svg";
export { ForwardRef as ReactComponent };